export enum FeatureName {
  VideoChat = 'VideoChat',
  LiveChat = 'LiveChat',
  IncognitoMode = 'IncognitoMode',
  JoinManagerToChatAsThirdParty = 'JoinManagerToChatAsThirdParty',
  AiAgent = 'AiAgent',
}
